export const language = [
    { id: '1', label: 'English' },
    { id: '2', label: 'Hindi' }
];